import { LOGISTIC_PIVOT_DIMENSIONS, type LogisticPivotDimension } from '../models/LogisticPivot';

const DIMENSION_SET = new Set<string>(LOGISTIC_PIVOT_DIMENSIONS);

/** Valor en URL cuando no hay ejes (totales agregados). Evita ambigüedad con cadena vacía en useQueryParams. */
export const NO_DIMENSIONS_URL_TOKEN = '-';

export function parseDimensionsParam(raw: string | undefined | null, fallback: LogisticPivotDimension[]): LogisticPivotDimension[] {
  if (raw === undefined || raw === null) return [...fallback];
  const trimmed = raw.trim();
  if (trimmed === '' || trimmed === NO_DIMENSIONS_URL_TOKEN) return [];
  const parsed = trimmed
    .split(',')
    .map((s) => s.trim())
    .filter((s): s is LogisticPivotDimension => DIMENSION_SET.has(s));
  const seen = new Set<LogisticPivotDimension>();
  const ordered: LogisticPivotDimension[] = [];
  for (const d of parsed) {
    if (!seen.has(d)) {
      seen.add(d);
      ordered.push(d);
    }
  }
  return ordered.length > 0 ? ordered : [...fallback];
}

export function serializeDimensionsParam(dims: LogisticPivotDimension[]): string {
  if (dims.length === 0) return NO_DIMENSIONS_URL_TOKEN;
  return dims.join(',');
}
